/**
 * Pagination facts shared by every awards-service list hook and mapper.
 *
 * pageSize is fixed server-side at 15 and is not a request parameter — the
 * constant only backfills a response that omitted it. The server rejects
 * page < 1 or > MAX_PAGE with a 400 rather than clamping, so clampPage keeps
 * every request inside those bounds.
 */
export const DEFAULT_PAGE_SIZE = 15;

export const MAX_PAGE = 100000;

export const clampPage = (page) => Math.min(Math.max(Number(page) || 1, 1), MAX_PAGE);
